// src/modules/app-views/services/pages/Init/modals/DataImportModal/StepSettings.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { Card, Tag, Segmented, Typography } from 'antd';
import translateX from 'utils/translateX';

const { Text } = Typography;

// *******************************************************************************
// STEP CONTENT COMPONENT
// *******************************************************************************
const StepSettingsContent = ({ conflictStrategy, setConflictStrategy, duplicateKey }) => {
  // ─────────────────────────────────────────────────────────────────────────────
  // 9. UI
  // ─────────────────────────────────────────────────────────────────────────────
  return (
    <div>
      <Text type="secondary">{translateX('data_import_settings_description')}</Text>

      <Card size="small" style={{ marginTop: 16 }}>
        <div style={{ marginBottom: 16 }}>
          <Text strong style={{ display: 'block', marginBottom: 8 }}>
            {translateX('data_import_conflict_strategy')}
          </Text>
          <Segmented
            value={conflictStrategy}
            onChange={setConflictStrategy}
            options={[
              {
                label: translateX('data_import_conflict_ignore'),
                value: 'ignore',
              },
              {
                label: translateX('data_import_conflict_overwrite'),
                value: 'overwrite',
              },
            ]}
            block
          />
          <Text type="secondary" style={{ display: 'block', marginTop: 8, fontSize: 12 }}>
            {conflictStrategy === 'ignore'
              ? translateX('conflict_ignore_tooltip')
              : translateX('conflict_overwrite_tooltip')
            }
          </Text>
        </div>

        <div>
          <Text strong style={{ display: 'block', marginBottom: 8 }}>
            {translateX('data_import_duplicate_key')}
          </Text>
          <Tag color="blue">{duplicateKey || 'sku'}</Tag>
        </div>
      </Card>
    </div>
  );
};

// *******************************************************************************
// STEP CONFIGURATION
// *******************************************************************************
const stepSettings = ({ conflictStrategy, setConflictStrategy, duplicateKey, saveSettings }) => ({
  stepTitle: 'settings',
  stepTooltip: 'data_import_settings_description',
  content: () => (
    <StepSettingsContent
      conflictStrategy={conflictStrategy}
      setConflictStrategy={setConflictStrategy}
      duplicateKey={duplicateKey}
    />
  ),
  onNext: async () => {
    return await saveSettings();
  },
});

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default stepSettings;
